<div class="login-container">
  <div class="login-card">
    <img src="assets/logo-tasafy.png" alt="Tasafy Logo" class="logo" />
    <h1>Tasafy - Acciones Masivas</h1>
    <h2>Iniciar Sesión</h2>
    
    @if (errorMessage()) {
      <div class="error-message">
        {{ errorMessage() }}
      </div>
    }
    
    <form (ngSubmit)="onLogin()">
      <div class="form-group">
        <label for="username">Usuario</label>
        <input 
          type="text" 
          id="username" 
          name="username" 
          [(ngModel)]="username"
          class="form-control"
          [disabled]="isLoading()"
          required
        />
      </div>
      <div class="form-group">
        <label for="password">Contraseña</label>
        <input 
          type="password" 
          id="password" 
          name="password" 
          [(ngModel)]="password"
          class="form-control"
          [disabled]="isLoading()"
          required
        />
      </div>
      <button 
        type="submit" 
        class="btn-login"
        [disabled]="isLoading()"
      >
        {{ isLoading() ? 'Iniciando sesión...' : 'Login' }}
      </button>
    </form>
  </div>
</div>
